/**
 * Heinsson-Anpassung: Formular-Kopie an den eigenen Versanddienst
 * ---------------------------------------------------------------
 * Shopifys eingebauter Formularversand kann weder den Betreff aendern
 * noch eine Eingangsbestaetigung an den Absender schicken. Deshalb
 * schickt dieses Skript die Formulardaten zusaetzlich an einen eigenen
 * kleinen Dienst (Cloudflare Worker), der beide Mails uebernimmt.
 *
 * Der Shopify-Versand laeuft dabei UNVERAENDERT weiter -- das Formular
 * wird nicht abgefangen. Faellt der Dienst aus, geht also nichts
 * verloren; es kommt dann nur die alte Shopify-Mail an.
 *
 * Solange ENDPUNKT leer ist, tut das Skript gar nichts.
 */
(function () {
  'use strict';

  // Adresse des Versanddienstes (wird nach der Einrichtung eingetragen)
  var ENDPUNKT = '';

  // Welches Formular ist welche Art? Schluessel = id des <form>-Elements.
  var FORMULARE = {
    ContactForm: 'kontakt',
    WiderrufForm: 'widerruf',
  };

  if (!ENDPUNKT) return;

  var HONIGTOPF = 'hp_website';

  // Unsichtbares Feld einbauen: Menschen sehen es nicht, viele Bots
  // fuellen es trotzdem aus -- solche Einsendungen verwirft der Dienst.
  function honigtopfEinbauen(form) {
    if (form.querySelector('[name="' + HONIGTOPF + '"]')) return;
    var f = document.createElement('input');
    f.type = 'text';
    f.name = HONIGTOPF;
    f.tabIndex = -1;
    f.autocomplete = 'off';
    f.setAttribute('aria-hidden', 'true');
    f.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0';
    form.appendChild(f);
  }

  function beschriftung(form, el, rohname) {
    var lab = el.id ? form.querySelector('label[for="' + el.id + '"]') : null;
    if (!lab) return rohname;
    var text = (lab.textContent || '').replace(/\s+/g, ' ').replace(/\s*\*\s*$/, '').trim();
    // Sehr lange Labels (z. B. der Richtlinien-Satz an der Checkbox)
    // ergeben in der E-Mail keine brauchbare Tabellenzeile.
    return !text || text.length > 60 ? rohname : text;
  }

  function sammle(form) {
    var felder = [];
    var email = '';
    var name = '';

    var els = form.querySelectorAll(
      'input[name^="contact["], select[name^="contact["], textarea[name^="contact["]'
    );

    Array.prototype.forEach.call(els, function (el) {
      var roh = el.name.replace(/^contact\[/, '').replace(/\]$/, '');
      var wert;

      if (el.type === 'checkbox') {
        wert = el.checked ? 'Ja' : 'Nein';
      } else if (el.type === 'radio') {
        if (!el.checked) return;
        wert = el.value;
      } else {
        wert = (el.value || '').trim();
      }

      if (roh === 'email') email = wert;
      if (el.getAttribute('autocomplete') === 'name' && wert) name = wert;

      felder.push({ label: beschriftung(form, el, roh), value: wert });
    });

    var hp = form.querySelector('[name="' + HONIGTOPF + '"]');

    return {
      formType: FORMULARE[form.id],
      locale: (document.documentElement.lang || 'de').slice(0, 2).toLowerCase(),
      pageUrl: window.location.href,
      email: email,
      name: name,
      hp: hp && hp.value ? hp.value : '',
      fields: felder,
    };
  }

  function bereitmachen() {
    Object.keys(FORMULARE).forEach(function (id) {
      var form = document.getElementById(id);
      if (form && form.tagName === 'FORM') honigtopfEinbauen(form);
    });
  }

  // Mitlesen statt abfangen: kein preventDefault, der normale
  // Shopify-Versand laeuft unveraendert weiter.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !FORMULARE[form.id]) return;
      if (form.checkValidity && !form.checkValidity()) return;

      try {
        // keepalive sorgt dafuer, dass die Anfrage auch dann noch
        // rausgeht, wenn die Seite im selben Moment neu laedt.
        // Content-Type text/plain vermeidet die CORS-Vorabfrage, die
        // beim Seitenwechsel sonst abgebrochen wuerde.
        fetch(ENDPUNKT, {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(sammle(form)),
        }).catch(function () {});
      } catch (err) {
        /* Niemals den Formularversand blockieren. */
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bereitmachen);
  } else {
    bereitmachen();
  }
})();
